<div class="modal-header">
    <h4 class="modal-title" ngbAutofocus>Chat Unavailable</h4>
    <button type="button" class="close btn btn-secondary" ee-google-tag="X button" (click)="onDismiss()">X</button>
</div>
<div class="modal-body">
    <h3>Thank you for contacting Emerson Ecologics!</h3>
    <p>We are currently closed, please <a ee-google-tag="Email instead of chat link" class="underline hyperlink" target="_blank" href="mailto:cs@emersonecologics.com">email</a> us your questions and we'll return your message as soon as possible.</p>
    <p>Our chat representatives are available M-F 8:30AM to 8:00PM EST</p>
</div>